/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Gesture_PreviousInputs */

const en_us2_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`previous`)
};

const pt_br2_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anterior`)
};

const es_419_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anterior`)
};

const pt_pt2_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`anterior`)
};

const fr_fr2_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`précédent`)
};

const de_de2_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vorherige`)
};

const it_it2_ui_gesture_previous = /** @type {(inputs: Ui_Gesture_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`precedente`)
};

/**
* | output |
* | --- |
* | "previous" |
*
* @param {Ui_Gesture_PreviousInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_gesture_previous = /** @type {((inputs?: Ui_Gesture_PreviousInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Gesture_PreviousInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_gesture_previous(inputs)
	if (locale === "es-419") return es_419_ui_gesture_previous(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_gesture_previous(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_gesture_previous(inputs)
	if (locale === "de-DE") return de_de2_ui_gesture_previous(inputs)
	if (locale === "it-IT") return it_it2_ui_gesture_previous(inputs)
	return en_us2_ui_gesture_previous(inputs)
});
export { ui_gesture_previous as "ui-gesture.previous" }